import * as actionTypes from 'actions';
import { EnvTypes } from 'constants/envTypes';

const initialState = {
  currentEnviromentType: EnvTypes.PRD,
  useLightTheme: false,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
  case actionTypes.SET_CURRENT_ENVIROMENT_TYPE:
      return {
        ...state,
        currentEnviromentType: action.payload,
      };
  case actionTypes.TOGGLE_LIGHT_THEME:
      return {
        ...state,
        useLightTheme: !state.useLightTheme,
      };
  case actionTypes.SET_LIGHT_THEME:
      return {
        ...state,
        useLightTheme: action.payload,
      };
  case actionTypes.SESSION_LOGOUT:
  case actionTypes.SESSION_LOGOUT_PM:
  case actionTypes.SESSION_LOGOUT_INVESTIGATED:
      return {
        ...state,
        useLightTheme: false,
      };
  default:
    return state;
  }
};

export default sessionReducer;
